import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChildren,
  QueryList,
  ViewContainerRef
} from '@angular/core';

import { CalendarInnerComponent } from './calendar-inner.component';
import * as moment_ from '../utilities/lib-moment/moment-with-locales.custom.min';

import {
  getBrowserLocale
} from './calendar-utility';

const moment = moment_;
@Component({
  selector: 'axis-calendar-monthpicker',
  template: `
<table *ngIf="calendar.datepickerMode==='month'" role="grid">
  <thead>
    <tr>
      <th>
        <button type="button" axis-button data-kind="icon"
                (click)="calendar.move(-1)" tabindex="-1">
          <span class="material-icons">keyboard_arrow_left</span>
        </button></th>
      <th [attr.colspan]="(((calendar.monthColLimit - 2) <= 0) ? 1 : (calendar.monthColLimit - 2))">
        <button [id]="calendar.uniqueId + '-title'"
              type="button" axis-button class="datepicker-btn" 
              (click)="calendar.toggleMode(1)"
            tabindex="-1">{{title}}
        </button>
      </th>
      <th>
        <button  type="button" axis-button data-kind="icon"
                (click)="calendar.move(1)" tabindex="-1">
          <span class="material-icons">keyboard_arrow_right</span>
        </button>
      </th>
    </tr>
  </thead>
  <tbody class="tbody-month">
    <tr *ngFor="let rowz of rows">
      <td *ngFor="let dtz of rowz" role="gridcell" id="{{dtz.uid}}">
        <button   #monthRef  type="button" class="axis-btn"
                [ngClass]="{
                  'btn-link': !dtz.selected && !calendar.isActive(dtz),
                  'date-selected': (dtz.selected && calendar.monthSelected)|| dtz.startDate || dtz.endDate,
                  'date-disabled': dtz.disabled
                }"
                (click)="calendar.select(dtz.date)" tabindex="-1">
          <span >{{dtz.label}}</span>
        </button>
      </td>
    </tr>
  </tbody>
</table>
  `
})
export class MonthPickerCalendarComponent implements OnInit {
  public title: string;
  public rows: any[] = [];
  public calendar: CalendarInnerComponent;
  public maxMode: string;
  private localeLanguage: string;

  public selectedMonth: any;
  public selectedYearNumber: any;
  public validKeyPressed = false;
  @ViewChildren('monthRef') monthRef: QueryList<ViewContainerRef>;
  public constructor(calendar: CalendarInnerComponent, private el: ElementRef) {
    this.calendar = calendar;
  }

  public ngOnInit(): void {
    this.calendar.monthSelected = true;
    let self: any = '';
    self = this;
    this.calendar.stepMonth = { years: 1 };
    this.calendar.setRefreshViewHandler(function (): void {
      const months: any[] = new Array(12);
      const year: number = this.activeDate.getFullYear();
      let date: Date;
      if (self.calendar.browserLocale) {
        self.localeLanguage = getBrowserLocale();
        moment.locale(self.localeLanguage);
      } else {
        self.localeLanguage = 'en-US';
        moment.locale(self.localeLanguage);
      }
      for (let i = 0; i < 12; i++) {
        date = new Date(year, i, 1);
        date = this.fixTimeZone(date);
        months[i] = this.createDateObject(date, this.formatMonth);
        months[i].uid = this.uniqueId + '-' + i;
      }
      self.title = this.dateFilter(this.activeDate, this.formatMonthTitle);
      self.rows = this.split(months, self.calendar.monthColLimit);
    }, 'month');

    this.calendar.setCompareHandler(function (
      date1: Date,
      date2: Date
    ): number {
      if (date1 !== null && date2 !== null) {
        const d1 = new Date(date1.getFullYear(), date1.getMonth());
        const d2 = new Date(date2.getFullYear(), date2.getMonth());
        return d1.getTime() - d2.getTime();
      }
    }, 'month');
    this.calendar.refreshView();
  }
  @HostListener('keyup', ['$event', 'this.monthRef'])
  onKeyUp(e: any, monthRef: any) {
    e.preventDefault();
    this.validKeyPressed = true;
    if ((e.code !== 'Tab' || e.keyCode !== 9) && this.calendar.datepickerMode === 'month') {
      this.monthUpdateOnKeyPress(monthRef, e);
    }
  }
  /**
    * Key events for the calendar.
    * TAB: moves focus to calendar.
    * LEFT_ARROW: Go to previous month.
    * RIGHT_ARROW: Go to next month.
    * UP_ARROW: Go up a row (back 4 months).
    * DOWN_ARROW:Go down a row (forward 4 months).
    * HOME: Go to the first month in the current range.
    * END: Go to the last month in the current range.
    * PAGE_UP: Go to the same month in the previous year
    * PAGE_DOWN:Go to the same month in the next year
    * ALT + PAGE_UP:Go to the same month 10 years back
    * ALT + PAGE_DOWN:Go to the same month 10 years forward
    * ENTER:Select current month

    * @param event as KeyboardEvent
    */
  monthUpdateOnKeyPress(monthRef: any, e: any) {
    this.selectedYearNumber = parseInt(this.title, 10);
    monthRef.forEach(element => {
      const tempElement = element.nativeElement;
      if (e.code === 'Home' || e.keyCode === 36) {
        this.selectedMonth = new Date(this.selectedYearNumber, 0, 1);
        this.calendar.monthSelected = true;
      } else if (e.code === 'End' || e.keyCode === 35) {
        this.selectedMonth = new Date(this.selectedYearNumber, 11, 1);
        this.calendar.monthSelected = true;
      } else if (
        tempElement.classList.contains('date-selected')
      ) {
        const selectedMonthName = element.nativeElement.textContent;
        const intialselectedMonth = moment().month(selectedMonthName).format('M');
        const selectedMonthNumber = parseInt(intialselectedMonth, 10);
        this.selectedMonth = new Date(this.selectedYearNumber, (selectedMonthNumber - 1), 1);
        if (e.code === 'ArrowRight' || e.keyCode === 39) {
          this.selectedMonth.setMonth(selectedMonthNumber);
        } else if (e.code === 'ArrowLeft' || e.keyCode === 37) {
          this.selectedMonth.setMonth(selectedMonthNumber - 2);
        } else if (e.code === 'ArrowDown' || e.keyCode === 40) {
          this.selectedMonth.setMonth(selectedMonthNumber + 2);
        } else if (e.code === 'ArrowUp' || e.keyCode === 38) {
          this.selectedMonth.setMonth(selectedMonthNumber - 4);
        } else if ((e.code === 'PageUp' || e.keyCode === 33) && e.altKey === false) {
          this.selectedMonth = new Date(this.selectedYearNumber - 1, (selectedMonthNumber - 1), 1);
        } else if ((e.code === 'PageDown' || e.keyCode === 34) && e.altKey === false) {
          this.selectedMonth = new Date(this.selectedYearNumber + 1, (selectedMonthNumber - 1), 1);
        } else if (e.altKey === true && (e.code === 'PageDown' || e.keyCode === 34)) {
          this.selectedMonth = new Date(this.selectedYearNumber + 10, (selectedMonthNumber - 1), 1);
        } else if (e.altKey === true && (e.code === 'PageUp' || e.keyCode === 33)) {
          this.selectedMonth = new Date(this.selectedYearNumber - 10, (selectedMonthNumber - 1), 1);
        } else {
          this.validKeyPressed = false;
        }

        if (this.validKeyPressed) {
          this.calendar.select(this.selectedMonth, false);
        }

        this.calendar.monthSelected = true;
        if (e.code === 'Enter' || e.keyCode === 13) {
          this.calendar.select(this.selectedMonth, true);
        }
      }
    });
  }
}
